/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.artikel-aktionen.service.ts.
 */
import {AppViewService} from './app.view.service';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Artikel} from '../models/artikel';
import {ArtikelAktion} from '../models/artikel-aktion';
import {AppAsyncTimeout} from '../helpers/app.asyncTimeout';
import {map} from 'rxjs/operators';
import {AppPageloaderService} from './app.pageloader.service';

/**
 * Zweck: Beschreibt class AppArtikelAktionenService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppArtikelAktionenService {
  artikelAktionen = new BehaviorSubject({});


  loadingArt: any = [];

  listenersForArtikelAktionen: any = {};

  unregisterlistenersForArtikelAktionenTimeout: any = {};


/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private vsvc: AppViewService, private loader: AppPageloaderService) {
  }

/**
 * Beschreibt Methode unregisterListener und ihren Rückgabevertrag.
 */
  unregisterListener(artikel: Artikel) {
    if (this.listenersForArtikelAktionen[artikel.ArtikelNummer]) {
      this.listenersForArtikelAktionen[artikel.ArtikelNummer]--;
      if (this.listenersForArtikelAktionen[artikel.ArtikelNummer] == 0) {
        this.unregisterlistenersForArtikelAktionenTimeout[artikel.ArtikelNummer] = setTimeout(() => {
          if (this.listenersForArtikelAktionen[artikel.ArtikelNummer] == 0) {
            this.listenersForArtikelAktionen[artikel.ArtikelNummer] = undefined;
            delete this.listenersForArtikelAktionen[artikel.ArtikelNummer];
            const akt: any = this.artikelAktionen.value;
            akt[artikel.ArtikelNummer] = undefined;
            delete akt[artikel.ArtikelNummer];
            this.artikelAktionen.next(akt);
          }
        }, 5000);
      }
    }
  }

/**
 * Beschreibt Methode registerListener und ihren Rückgabevertrag.
 */
  registerListener(artikel: Artikel): Observable<ArtikelAktion[]> {
    if (!this.listenersForArtikelAktionen[artikel.ArtikelNummer]) {
      this.listenersForArtikelAktionen[artikel.ArtikelNummer] = 0;
    }
    this.listenersForArtikelAktionen[artikel.ArtikelNummer]++;

    return this.artikelAktionen.asObservable().pipe(map(a => {
      if (a && a[artikel.ArtikelNummer]) {
        return a[artikel.ArtikelNummer];
      } else {
        this.loadArtikelAktionen(artikel);
      }
    }));
  }

  private registerArtikelAktion(artikel: Artikel, aktionen: ArtikelAktion[]) {
    const akt: any = this.artikelAktionen.value;
    akt[artikel.ArtikelNummer] = aktionen;
    this.artikelAktionen.next(akt);
    this.loadingArt.splice(this.loadingArt.indexOf(artikel.ArtikelNummer), 1);
  }

  private loadArtikelAktionen(artikel: Artikel) {
    if (!this.loadingArt.includes(artikel.ArtikelNummer) && !this.artikelAktionen.value[artikel.ArtikelNummer]) {
      this.loadingArt.push(artikel.ArtikelNummer);
      if (artikel.ArtikelHatAktion === true || artikel.ArtikelHatAktion === null) {
        AppAsyncTimeout.setTimeout(() => {
          const l = this.loader.start();
          this.vsvc.getAktionenSlug(artikel.view.slug, artikel).subscribe(a => {
            this.registerArtikelAktion(artikel, a);
            l.stop();
          });
        }, 100);
      }
    }
  }
}
